import React, { useLayoutEffect, useEffect } from "react";
import icon from "../images/bejour-icon.svg";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function About() {
  useLayoutEffect(() => {
    let tlFigureContainer = document.querySelector(".tl-figure-container");
    //let tlMain = document.querySelector(".tl-main");
    let firstOrb = document.querySelector("#first-tl-marker");

    let firstOrbMeasures = firstOrb.getBoundingClientRect();
    let tlPathWidth = document.querySelector(".tl-figure-path").getBoundingClientRect().width;

    let fromTop = firstOrb.offsetTop + firstOrbMeasures.height / 2;
    let fromLeft = firstOrbMeasures.width / 2 - tlPathWidth;
    tlFigureContainer.style.transform = `translate(${fromLeft}px, ${fromTop}px)`; //x then y
  });

  //intro Animation
  useEffect(() => {
    //const staggerAmount = 0.9;
    // const staggerEach = 0.2;
    // //***Intro
    let tl_intro = gsap.timeline();

    // let introReveal = gsap
    //   .fromTo(
    //     ".about h1 > div > span",
    //     { y: "100%" },
    //     {
    //       y: "0",
    //       stagger: staggerEach,
    //     },
    //     0
    //   )
    //   //.delay(history.action === "POP" ? 0.6 : 0.4);
    //   .delay(0.3);
    tl_intro
      //.add(introReveal)
      .fromTo(
        ".intro-text h2",
        { autoAlpha: 0, y: 5 },
        { autoAlpha: 1, y: 0, duration: 0.8, delay: 0.1 },
        ">"
      )
      .fromTo(
        ".intro-text p:nth-of-type(1)",
        { autoAlpha: 0 },
        { autoAlpha: 1, duration: 1.5 },
        "<+=0.3"
      )
      .fromTo(
        ".intro-text p:nth-of-type(2)",
        { autoAlpha: 0 },
        { autoAlpha: 1, duration: 1.5 },
        "<+=0.25"
      )
      .fromTo(
        ".intro-text h3",
        { autoAlpha: 0, yPercent: 100 },
        { autoAlpha: 1, yPercent: 0, duration: 0.8 },
        "<+=0.15"
      );
    return () => {
      tl_intro.kill();
    };
  });

  //Animations
  useLayoutEffect(() => {
    const dimensions = {
      height: window.innerHeight,
      width: window.innerWidth,
    };
    //let borderWidth = document.querySelector(".border-svg").getBoundingClientRect().width;
    // document.querySelector(".border-mask.first").setAttribute("d", `M 0 5 l ${borderWidth} 0`);
    // document.querySelector(".border-svg").setAttribute("width", `${borderWidth}`);

    let tlHeight = document.querySelector(".tl-figure-container").getBoundingClientRect().height;
    document.querySelector(".tl-figure-path").setAttribute("d", `M 0 0 l 0 ${tlHeight}`);
    //document.querySelector("#tl-mask-full").setAttribute("d", `M-50 0h100v${tlHeight}h-100z`);

    var wrap = function (toWrap) {
      let wrapper = document.createElement("div");
      wrapper.className = "span-wrapper";
      toWrap.parentNode.appendChild(wrapper);
      return wrapper.appendChild(toWrap);
    };

    function wrapSpans(spans) {
      Array.prototype.forEach.call(spans, function (span) {
        if (span.parentElement.className !== "span-wrapper") {
          wrap(span);
        }
      });
    }

    let header_spans = document.querySelectorAll("h1 > span");
    let why_spans = document.querySelectorAll("h2 > span");

    wrapSpans(header_spans);
    wrapSpans(why_spans);

    const staggerAmount = 1;
    const staggerEach = 0.1;
    // //***Intro
    // let tl_intro = gsap.timeline();

    // let introReveal = gsap
    //   .fromTo(
    //     "h1 > div > span",
    //     { yPercent: 100 },
    //     {
    //       yPercent: 0,
    //       stagger: staggerEach,
    //     },
    //     0
    //   )
    //   .duration(staggerAmount)
    //   .delay(history.action === "POP" ? 0.6 : 0.4);
    // tl_intro
    //   .add(introReveal)
    //   .fromTo(".intro-text h2", { autoAlpha: 0, y: 10 }, { autoAlpha: 1, y: 0, duration: 0.5 }, ">")
    //   .fromTo(
    //     ".intro-text h3",
    //     { autoAlpha: 0, y: 5 },
    //     { autoAlpha: 1, y: 0, duration: 0.2 },
    //     ">-=0.2"
    //   )
    //   .fromTo(".intro-text p", { autoAlpha: 0, y: 10 }, { autoAlpha: 1, y: 0, duration: 0.2 }, ">");

    //***Why
    let tl_why = gsap.timeline({
      scrollTrigger: {
        id: "why",

        trigger: ".tl-section  h2 > div > span",
        start: "top-=100 center",
      },
    });

    // let whyReveal = gsap
    //   .fromTo(
    //     ".tl-section  h2 > div > span",
    //     { yPercent: 100 },
    //     {
    //       yPercent: 0,
    //       stagger: staggerEach - 0.05,
    //     },
    //     0
    //   )
    //   .duration(staggerAmount - 0.2);

    var isSafari =
      navigator.vendor &&
      navigator.vendor.indexOf("Apple") > -1 &&
      navigator.userAgent &&
      navigator.userAgent.indexOf("CriOS") == -1 &&
      navigator.userAgent.indexOf("FxiOS") == -1;

    tl_why
      .fromTo(
        ".tl-section  h2 > div > span",
        { yPercent: 100 },
        {
          yPercent: 0,
          stagger: staggerEach - 0.05,
          duration: staggerAmount - 0.2,
        },
        "<"
      )
      .fromTo(
        ".tl-section .border-svg",
        {
          clipPath: () => {
            if (!isSafari) {
              return "polygon(0 0, 0 0, 0 100%, 0 100%)";
            }
          },
          opacity: () => {
            if (isSafari) {
              return 0;
            }
          },
        },
        {
          clipPath: () => {
            if (!isSafari) {
              return "polygon(0% 0, 100% 0, 100% 100%, 0% 100%)";
            }
          },
          opacity: () => {
            if (isSafari) {
              return 1;
            }
          },
          duration: 1,
        },
        "<"
      );
    // .fromTo(
    //   ".border-mask.first",
    //   {
    //     strokeDasharray: borderWidth,
    //     strokeDashoffset: borderWidth,
    //   },
    //   { strokeDashoffset: 0, duration: 1 },
    //   "<"
    // );
    //***Trend
    let animFigure = gsap.fromTo(
      ".tl-figure-container",
      {
        clipPath: "polygon(-10% 0, 100% 0, 100% 0, -10% 0)",
      },
      {
        clipPath: "polygon(-10% 0, 100% 0, 100% 103%, -10% 103%)",
        scrollTrigger: {
          trigger: ".tl-figure-container",
          start: "top center",
          endTrigger: "#second-tl-marker",
          end: "center+=200 center",
          scrub: 1,
        },
        ease: "linear",
      }
    );
    let trendWmAnim = gsap.fromTo(
      ".wtm-header.trd",
      {
        autoAlpha: 0,
        x: -100,
      },
      {
        autoAlpha: 1,
        x: 0,
        scrollTrigger: {
          id: "firstEntry",
          trigger: "#first-tl-entry",
          start: "top center",
          scrub: 1,
        },
      }
    );

    //Trend first Entry
    let tl_firstEntry = gsap.timeline({
      scrollTrigger: {
        id: "firstEntry",
        trigger: "#first-tl-entry",
        start: "top center",
      },
    });
    tl_firstEntry
      .fromTo(
        "#first-tl-entry  .tl-marker",
        { yPercent: 10, autoAlpha: 0 },
        { yPercent: 0, autoAlpha: 1, duration: 0.5 },
        ">"
      )
      .fromTo(
        "#first-tl-entry  p",
        { yPercent: 10, autoAlpha: 0 },
        { yPercent: 0, autoAlpha: 1, duration: 0.5 },
        "<"
      )
      .fromTo(
        "#first-tl-entry  .ab-quote-author",
        { yPercent: 10, autoAlpha: 0 },
        { yPercent: 0, autoAlpha: 1, duration: 0.5 },
        "<+=0.1"
      )
      .fromTo(
        "#first-tl-entry .date-container  div",
        { yPercent: 100 },
        { yPercent: 0, duration: 0.5 },
        ">"
      );

    //Trend subentries
    let tl_subEntries = gsap.timeline({
      scrollTrigger: {
        trigger: ".ab-subentries.trd",
        start: "top center",
      },
    });
    tl_subEntries.fromTo(
      ".ab-subentry.trd",
      { autoAlpha: 0 },
      { autoAlpha: 1, stagger: staggerEach + 0.2 }
    );
    //Trend second Entry
    let tl_secondEntry = gsap.timeline({
      scrollTrigger: {
        trigger: "#second-tl-marker",
        start: "center center",
      },
    });
    tl_secondEntry
      .fromTo(
        "#second-tl-entry  .tl-marker",
        { yPercent: 10, autoAlpha: 0 },
        { yPercent: 0, autoAlpha: 1, duration: 0.5 },
        ">"
      )
      .fromTo(
        "#second-tl-entry  p",
        { yPercent: 10, autoAlpha: 0 },
        { yPercent: 0, autoAlpha: 1, duration: 0.5 },
        "<"
      )
      .fromTo(
        "#second-tl-entry  .ab-quote-author",
        { yPercent: 10, autoAlpha: 0 },
        { yPercent: 0, autoAlpha: 1, duration: 0.5 },
        "<+=0.1"
      )
      .fromTo(
        "#second-tl-entry .date-container  div",
        { yPercent: 100 },
        { yPercent: 0, duration: 0.5 },
        ">"
      );

    //***Evidence
    let tl_firstEvdQuote = gsap.timeline({
      scrollTrigger: {
        trigger: ".first-evd-quote .ab-quote-text",
        start: "top center",
      },
    });
    tl_firstEvdQuote.fromTo(".first-evd-quote .ab-quote-text", { autoAlpha: 0 }, { autoAlpha: 1 });
    tl_firstEvdQuote.fromTo(
      ".first-evd-quote .ab-quote-author",
      { autoAlpha: 0 },
      { autoAlpha: 1 },
      ">-=0.1"
    );
    tl_firstEvdQuote.fromTo(
      ".first-evd-quote .ab-quote-subauthor",
      { autoAlpha: 0 },
      { autoAlpha: 1 },
      "<"
    );

    let tl_subEvdQuote = gsap.timeline({
      scrollTrigger: {
        trigger: ".ab-subentries.evd",
        start: "top center",
      },
    });
    tl_subEvdQuote.fromTo(
      ".ab-subentry.evd",
      { autoAlpha: 0 },
      { autoAlpha: 1, stagger: staggerEach + 0.3 }
    );

    let evdWtmAnim = gsap.fromTo(
      ".wtm-header.evd",
      {
        autoAlpha: 0,
        x: -100,
      },
      {
        autoAlpha: 1,
        x: 0,
        scrollTrigger: {
          trigger: ".first-evd-quote",
          start: "top center",
          scrub: 1,
        },
      }
    );
    let evdFigureAnim = gsap.fromTo(
      ".evd-figure-container",
      {
        clipPath: "polygon(0 0, 0 0, 0 100%, 0 100%)",
        autoAlpha: 0,
      },
      {
        clipPath: "polygon(0% 0, 100% 0, 100% 100%, 0% 100%)",
        autoAlpha: 1,
        scrollTrigger: {
          // trigger: ".first-evd-quote",
          // start: "top center",
          trigger: ".ab-subentries.evd",
          start: "top center",
          // endTrigger: ".ab-subentries.evd",
          // end: "top center",
          // scrub: 2,
          toggleActions: "play none none reverse",
        },
        //delay: 0.8,
        duration: 1.7,
        ease: "power1.out",
      }
    );

    //***Conclusion

    let tl_conc = gsap.timeline({
      scrollTrigger: {
        trigger: ".wtm-header.conc",
        start: () => `${dimensions.height >= 1300 ? "top" : "center"} center`,
        toggleActions: "play none none reverse",
      },
    });
    tl_conc
      .fromTo(
        ".wtm-header.conc",
        {
          opacity: 0,
          x: -60,
        },
        {
          opacity: 1,
          x: 0,
          duration: 0.5,
        }
      )
      .fromTo(
        "#conc-icon",
        {
          opacity: 0,
          y: 10,
        },
        {
          opacity: 1,
          y: 0,
        },
        ">-=0.3"
      );

    return () => {
      //tl_intro.kill();
      tl_why.kill();
      animFigure.kill();
      tl_firstEntry.kill();
      tl_subEntries.kill();
      tl_secondEntry.kill();
      trendWmAnim.kill();

      tl_firstEvdQuote.kill();
      tl_subEvdQuote.kill();
      evdWtmAnim.kill();
      evdFigureAnim.kill();

      tl_conc.kill();
      // concWtmAnim.kill();
      // concLogoAnim.kill();
    };
  });

  return (
    <>
      <div className="section-container about">
        <section className="intro-section">
          <div className="intro-row">
            <h1>
              <span className="span-anim">
                <span className="grad-acc-clr ">B</span>
                <span>ehavioral </span>
              </span>
              <span>
                <span className="grad-acc-clr">E</span>
                <span>conomics </span>
              </span>
              <span>
                <span className="grad-acc-clr">Jour</span>
                <span>nal</span>
              </span>
            </h1>
            <div className="intro-text">
              <h2>Know yourself</h2>
              <div className="meets-container">
                <h3>Economics meets Psychology</h3>
              </div>
              <p>
                <span className="text-acc-clr-400">BE</span> is a discipline that combines economic
                theory with psychological insights. It knows that human economic behavior is riddled
                with irrationalities and tries to describe, explain and remedy them.
              </p>
              <p>
                This
                <span className="text-acc-clr-400"> Behavioral Economics [Trading] Journal </span>
                aims to be your guide in navigating your own biases and improve the decisions you
                make, economic or other. But why should you care? Why now?
              </p>
            </div>
            <div className="circle-container">
              <div className="large-circle"> </div>
              <div className="small-circle"> </div>
            </div>
          </div>
        </section>
        <section className="tl-section">
          <div>
            <h2>
              <span>But </span>
              <span>why...</span>
            </h2>
            <div className="svg-container">
              <svg className="border-svg" height="50px" width="600px">
                <defs>
                  {/* <mask id="id-border-mask-first">
                    <path className="border-mask first" d="M 0 5 l 600 0 M 0 8 l 600 0" />
                  </mask> */}
                </defs>

                <path
                  height="50px"
                  className="border-path"
                  d="M 0 5 l 600 0 M 0 8 l 600 0"
                  //mask="url(#id-border-mask-first)"
                />
              </svg>
            </div>
          </div>
          <div className="tl-main">
            <h3 className="wtm-header trd">
              A New <br></br> Trend
            </h3>
            <div className="tl-figure-container">
              <svg className="tl-figure" height="100%" width="100%">
                <defs>
                  <marker
                    id="arrow"
                    viewBox="0 0 50 50"
                    refX="0"
                    refY="12.5"
                    markerWidth="8"
                    markerHeight="10"
                    orient="auto-start-reverse"
                  >
                    <path d="M 0 0 L 25 12.5 L 0 25 z" />
                  </marker>
                  {/* <linearGradient id="gradient" gradientTransform="rotate(90)">
                    <stop offset="0" stop-color="transparent" />
                    <stop offset="0.2" stop-color="transparent" />
                    <stop offset="0.2" stop-color="#FFFFFF" />
                    <stop offset="1" stop-color="white" />
                  </linearGradient> */}
                  {/* <mask
                    id="tl-mask-full"
                    maskUnits="userSpaceOnUse"
                    height="800"
                    transform="scale(0.001 0.5)"
                  >
                    <path d="M-50 0h100v1000h-100z" fill="white" />
                  </mask> */}
                </defs>

                <path
                  className="tl-figure-path"
                  d="M 0 0 l 0 1000 "
                  //mask="url(#tl-mask-full)"
                  markerEnd="url(#arrow)"
                />
                {/* 
                <path
                  className="tl-mask-full"
                  d="M-50 0h100v1000h-100z"
                  fill="url(#gradient)"
                  //mask="url(#tl-mask-full)"
                /> */}
              </svg>
            </div>
            <div>
              <div id="first-tl-entry" className="tl-entry-wrapper">
                <div className="date-container">
                  <div>12/2020</div>
                </div>
                <div className="tl-entry">
                  <div id="first-tl-marker" className="tl-marker"></div>
                  <p className="ab-quote-text">
                    "Individual investors opened more than 10 million new brokerage accounts in 2020
                    [...] a record"
                  </p>
                </div>
                <div className="ab-quote-author">Wall Street Journal</div>
              </div>
              <div className="ab-subentries trd">
                <div className="ab-subentry trd">
                  <p>"And these retail investors are trading a lot"</p>
                  <div>Forbes Magazine</div>
                  <div>02/2021</div>
                </div>
                <div className="ab-subentry trd">
                  <p>
                    "Their stock market footprint is roughly as big as all hedge funds and mutual
                    funds combined"
                  </p>
                  <div>Financial Times</div>
                  <div>03/2021</div>
                </div>
              </div>
              <div id="second-tl-entry" className="tl-entry-wrapper">
                <div className="date-container">
                  <div>06/2021</div>
                </div>
                <div className="tl-entry">
                  <div id="second-tl-marker" className="tl-marker"></div>
                  <p className="ab-quote-text">
                    "New brokerage accounts [...] have already roughly matched the total created
                    throughout 2020"
                  </p>
                </div>
                <div className="ab-quote-author">Wall Street Journal</div>
              </div>
            </div>
          </div>
        </section>
        <section className="evd-section">
          <h3 className="wtm-header evd">
            The <br></br> Evidence
          </h3>
          <div className="evd-quotes">
            <div className="first-evd-quote">
              <p className="ab-quote-text">
                “Individual investors who hold common stocks directly pay a tremendous performance
                penalty for active trading.”
              </p>
              <div className="ab-quote-author">Barber and Odean (2000)</div>
              <div className="ab-quote-subauthor">The Journal of Finance</div>
            </div>
            <div className="ab-subentries evd">
              <div className="ab-subentry evd">
                <p>
                  "Stocks with high retail trading proportion [...] earn significantly negative
                  alpha"
                </p>
                <div>Han and Kumar (2013)</div>
                <div>Journal of Financial and Quantitative Analysis</div>
              </div>
              <div className="ab-subentry evd">
                <p>
                  "Individual investor trading results in systematic and economically large losses."
                </p>
                <div>Barber et al. (2009)</div>
                <div>The Review of Financial Studies</div>
              </div>
            </div>
          </div>
          <figure className="evd-figure-container">
            <svg
              width="1262"
              height="661"
              viewBox="0 0 1262 661"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M171.5 10.785C60 36.2361 3 195.285 3 195.285V660.285H1261.5C1261.5 660.285 1082.5 400.284 995 365.785C907.5 331.286 800 574.285 690.5 580.781C581 587.277 283 -14.6661 171.5 10.785Z"
                fill="url(#paint0_radial_215:18)"
              />
              <path
                d="M690.5 573.781L690.648 576.277L690.5 573.781ZM1261.5 653.285L1259.09 624.518L1235.38 640.988L1261.5 653.285ZM3 188.285C5.35343 189.128 5.35341 189.128 5.35339 189.128C5.35339 189.128 5.35337 189.129 5.35336 189.129C5.35335 189.129 5.35334 189.129 5.35335 189.129C5.35336 189.129 5.3534 189.128 5.35348 189.128C5.35364 189.128 5.35394 189.127 5.35438 189.126C5.35526 189.123 5.35672 189.119 5.35874 189.114C5.36279 189.102 5.36911 189.085 5.37771 189.061C5.39492 189.014 5.42122 188.941 5.45663 188.845C5.52745 188.652 5.63466 188.362 5.77823 187.979C6.06537 187.214 6.49791 186.081 7.0755 184.616L2.42404 182.782C1.83598 184.273 1.39363 185.432 1.0973 186.222C0.949135 186.616 0.837465 186.918 0.762332 187.123C0.724765 187.226 0.696331 187.304 0.677036 187.357C0.667389 187.384 0.660026 187.404 0.654948 187.418C0.652409 187.425 0.650441 187.431 0.649044 187.435C0.648346 187.437 0.647791 187.438 0.647378 187.439C0.647172 187.44 0.647001 187.44 0.646867 187.441C0.646799 187.441 0.646741 187.441 0.646691 187.441C0.646666 187.441 0.646636 187.441 0.646623 187.441C0.646595 187.441 0.646569 187.441 3 188.285ZM10.8494 175.457C12.0026 172.762 13.3367 169.728 14.851 166.407L10.3016 164.332C8.77022 167.691 7.42046 170.761 6.25277 173.489L10.8494 175.457ZM19.0822 157.392C20.4448 154.569 21.9082 151.611 23.4722 148.539L19.0165 146.27C17.4358 149.375 15.9566 152.365 14.5793 155.218L19.0822 157.392ZM28.0726 139.738C29.5946 136.901 31.1926 133.994 32.8662 131.032L28.513 128.572C26.8207 131.568 25.2052 134.507 23.6666 137.374L28.0726 139.738ZM37.842 122.451C39.4997 119.665 41.2201 116.845 43.0032 114.003L38.7674 111.346C36.9628 114.223 35.2221 117.076 33.5453 119.894L37.842 122.451ZM48.367 105.677C50.1683 102.956 52.0255 100.224 53.9383 97.49L49.8417 94.6234C47.9032 97.3938 46.0218 100.162 44.1976 102.918L48.367 105.677ZM59.7239 89.4556C61.6749 86.8239 63.6774 84.1995 65.7315 81.5909L61.8032 78.4976C59.7179 81.1458 57.6859 83.8088 55.7073 86.478L59.7239 89.4556ZM71.9697 73.9142C74.08 71.3992 76.2393 68.9075 78.4477 66.4468L74.7265 63.1072C72.4796 65.6108 70.2839 68.1445 68.1394 70.7004L71.9697 73.9142ZM85.1747 59.2123C87.4556 56.8468 89.7841 54.5195 92.1602 52.238L88.6972 48.6314C86.273 50.9591 83.899 53.3319 81.5753 55.7418L85.1747 59.2123ZM99.4127 45.5547C101.875 43.3793 104.385 41.2572 106.941 39.1957L103.802 35.3036C101.186 37.4139 98.619 39.5844 96.1025 41.8073L99.4127 45.5547ZM114.751 33.1998C117.402 31.2657 120.1 29.4 122.844 27.6098L120.112 23.4221C117.293 25.2615 114.523 27.1769 111.804 29.1603L114.751 33.1998ZM131.219 22.4718C134.057 20.8402 136.94 19.2918 139.869 17.8338L137.642 13.3576C134.62 14.8616 131.648 16.4575 128.727 18.1373L131.219 22.4718ZM148.78 13.7451C151.785 12.4821 154.835 11.3157 157.931 10.2531L156.308 5.52391C153.103 6.62387 149.948 7.83046 146.843 9.13583L148.78 13.7451ZM167.292 7.4008C168.869 6.98051 170.457 6.58738 172.056 6.22229L170.944 1.34767C169.285 1.72625 167.639 2.13382 166.004 2.56944L167.292 7.4008ZM172.056 6.22229C173.52 5.88809 175.025 5.6706 176.572 5.56829L176.241 0.579199C174.442 0.698285 172.675 0.952528 170.944 1.34767L172.056 6.22229ZM185.917 6.23829C188.895 6.82095 192.001 7.74684 195.233 9.00978L197.053 4.35267C193.584 2.99709 190.189 1.97935 186.877 1.33133L185.917 6.23829ZM204.085 13.1379C206.81 14.6009 209.603 16.2658 212.461 18.1256L215.188 13.9347C212.226 12.0074 209.312 10.2693 206.45 8.73257L204.085 13.1379ZM220.776 23.9433C223.297 25.824 225.86 27.8373 228.463 29.978L231.639 26.1161C228.98 23.93 226.355 21.8677 223.766 19.9359L220.776 23.9433ZM236.172 36.5818C238.567 38.7116 240.991 40.9381 243.444 43.2575L246.879 39.6245C244.392 37.2727 241.93 35.0116 239.495 32.8457L236.172 36.5818ZM250.775 50.3781C253.054 52.6488 255.356 54.9925 257.678 57.4064L261.281 53.9395C258.936 51.5018 256.609 49.1329 254.304 46.8358L250.775 50.3781ZM264.709 64.8548C266.915 67.2347 269.138 69.6729 271.378 72.1667L275.098 68.8257C272.841 66.3135 270.601 63.8561 268.376 61.456L264.709 64.8548ZM278.069 79.7236C280.26 82.233 282.467 84.7918 284.687 87.3977L288.493 84.155C286.26 81.5343 284.04 78.9601 281.835 76.4346L278.069 79.7236ZM291.103 95.0112C293.254 97.5909 295.417 100.212 297.592 102.872L301.463 99.7073C299.278 97.0353 297.105 94.4019 294.943 91.8092L291.103 95.0112ZM303.896 110.651C305.971 113.234 308.056 115.851 310.151 118.498L314.072 115.397C311.97 112.739 309.877 110.113 307.794 107.52L303.896 110.651ZM316.461 126.535C318.488 129.136 320.524 131.765 322.568 134.419L326.53 131.37C324.48 128.707 322.438 126.07 320.404 123.461L316.461 126.535ZM328.683 142.412C330.729 145.101 332.782 147.814 334.841 150.55L338.836 147.544C336.772 144.801 334.714 142.081 332.663 139.385L328.683 142.412ZM340.827 158.543C342.822 161.218 344.823 163.914 346.828 166.628L350.849 163.657C348.84 160.937 346.835 158.236 344.836 155.554L340.827 158.543ZM352.861 174.825C354.827 177.507 356.798 180.206 358.774 182.92L362.816 179.978C360.838 177.26 358.863 174.556 356.894 171.869L352.861 174.825ZM364.684 191.068C366.658 193.798 368.636 196.542 370.617 199.298L374.677 196.38C372.693 193.62 370.712 190.872 368.735 188.138L364.684 191.068ZM376.484 207.482C378.428 210.202 380.376 212.933 382.326 215.673L386.4 212.774C384.447 210.031 382.498 207.297 380.551 204.574L376.484 207.482ZM388.184 223.924C390.127 226.665 392.072 229.416 394.019 232.173L398.104 229.29C396.155 226.53 394.208 223.777 392.264 221.033L388.184 223.924ZM399.816 240.399C401.75 243.147 403.686 245.902 405.623 248.662L409.716 245.79C407.778 243.028 405.841 240.271 403.905 237.521L399.816 240.399ZM411.431 256.947C413.355 259.695 415.28 262.447 417.205 265.202L421.303 262.338C419.377 259.582 417.451 256.829 415.527 254.08L411.431 256.947ZM422.983 273.475C424.909 276.236 426.836 278.998 428.763 281.761L432.864 278.902C430.937 276.138 429.01 273.375 427.083 270.614L422.983 273.475ZM434.537 290.045C436.461 292.806 438.384 295.568 440.307 298.328L444.41 295.469C442.487 292.709 440.563 289.948 438.639 287.187L434.537 290.045ZM446.074 306.604C448.001 309.369 449.928 312.132 451.852 314.892L455.954 312.032C454.029 309.273 452.103 306.51 450.177 303.745L446.074 306.604ZM457.638 323.183C459.565 325.943 461.491 328.699 463.414 331.449L467.512 328.584C465.589 325.834 463.664 323.08 461.738 320.321L457.638 323.183ZM469.195 339.707C471.138 342.48 473.079 345.247 475.017 348.006L479.109 345.132C477.171 342.374 475.232 339.609 473.289 336.838L469.195 339.707ZM480.824 356.26C482.757 359.003 484.687 361.737 486.614 364.462L490.696 361.575C488.771 358.853 486.843 356.121 484.912 353.38L480.824 356.26ZM492.492 372.76C494.45 375.517 496.403 378.262 498.353 380.996L502.423 378.092C500.476 375.362 498.525 372.619 496.569 369.865L492.492 372.76ZM504.188 389.157C506.17 391.922 508.147 394.672 510.119 397.406L514.174 394.482C512.205 391.751 510.231 389.005 508.252 386.244L504.188 389.157ZM516.055 405.613C518.029 408.332 519.997 411.035 521.959 413.72L525.996 410.769C524.037 408.089 522.072 405.391 520.102 402.676L516.055 405.613ZM527.965 421.903C529.984 424.643 531.997 427.363 534.003 430.061L538.015 427.077C536.014 424.386 534.006 421.672 531.99 418.937L527.965 421.903ZM539.998 438.086C542.047 440.815 544.088 443.519 546.12 446.197L550.103 443.174C548.076 440.504 546.04 437.806 543.996 435.084L539.998 438.086ZM552.284 454.269C554.329 456.931 556.366 459.565 558.392 462.169L562.338 459.097C560.318 456.502 558.288 453.877 556.248 451.223L552.284 454.269ZM564.7 470.21C566.816 472.888 568.921 475.53 571.014 478.134L574.912 475.002C572.827 472.408 570.731 469.777 568.622 467.11L564.7 470.21ZM577.279 485.859C579.486 488.555 581.678 491.205 583.856 493.81L587.692 490.602C585.526 488.012 583.344 485.374 581.148 482.692L577.279 485.859ZM590.347 501.48C592.579 504.086 594.795 506.64 596.994 509.139L600.748 505.835C598.564 503.354 596.363 500.818 594.144 498.227L590.347 501.48ZM603.793 516.744C606.066 519.247 608.32 521.685 610.553 524.057L614.193 520.629C611.982 518.28 609.748 515.864 607.494 513.382L603.793 516.744ZM617.736 531.522C620.106 533.93 622.451 536.256 624.77 538.496L628.244 534.9C625.957 532.691 623.642 530.395 621.3 528.015L617.736 531.522ZM632.392 545.63C634.917 547.914 637.409 550.087 639.866 552.142L643.074 548.307C640.671 546.296 638.228 544.167 635.747 541.922L632.392 545.63ZM648.089 558.673C650.916 560.793 653.696 562.741 656.424 564.506L659.14 560.308C656.519 558.612 653.834 556.731 651.088 554.672L648.089 558.673ZM665.289 569.679C668.606 571.39 671.848 572.795 675.01 573.866L676.613 569.13C673.724 568.151 670.712 566.851 667.582 565.235L665.289 569.679ZM685.379 576.172C687.165 576.342 688.923 576.379 690.648 576.277L690.352 571.286C688.899 571.372 687.399 571.341 685.851 571.195L685.379 576.172ZM690.648 576.277C692.387 576.174 694.125 576.013 695.861 575.796L695.242 570.835C693.611 571.038 691.981 571.189 690.352 571.286L690.648 576.277ZM706.141 573.874C709.475 573.048 712.799 572.03 716.114 570.836L714.42 566.132C711.255 567.272 708.095 568.238 704.938 569.021L706.141 573.874ZM725.725 566.883C728.815 565.457 731.897 563.889 734.97 562.192L732.553 557.815C729.577 559.459 726.603 560.972 723.63 562.343L725.725 566.883ZM743.871 556.907C746.73 555.094 749.583 553.177 752.43 551.165L749.544 547.082C746.761 549.049 743.977 550.92 741.193 552.685L743.871 556.907ZM760.675 545.066C763.35 543.002 766.019 540.861 768.682 538.652L765.49 534.804C762.868 536.978 760.245 539.082 757.621 541.107L760.675 545.066ZM776.482 531.977C779.027 529.735 781.567 527.436 784.101 525.088L780.703 521.42C778.197 523.743 775.688 526.013 773.177 528.226L776.482 531.977ZM791.515 518.067C793.947 515.717 796.375 513.326 798.797 510.9L795.26 507.367C792.856 509.773 790.45 512.144 788.04 514.472L791.515 518.067ZM805.971 503.609C808.333 501.174 810.689 498.713 813.041 496.23L809.41 492.792C807.071 495.262 804.729 497.709 802.382 500.127L805.971 503.609ZM820.014 488.793C822.324 486.307 824.63 483.804 826.931 481.292L823.243 477.915C820.949 480.42 818.652 482.913 816.351 485.39L820.014 488.793ZM833.796 473.752C836.077 471.235 838.353 468.712 840.624 466.191L836.908 462.845C834.64 465.364 832.367 467.882 830.091 470.395L833.796 473.752ZM847.437 458.614C849.71 456.084 851.977 453.56 854.239 451.048L850.523 447.703C848.259 450.217 845.991 452.742 843.718 455.272L847.437 458.614ZM861.055 443.498C863.346 440.968 865.631 438.456 867.91 435.968L864.222 432.591C861.936 435.087 859.645 437.606 857.349 440.141L861.055 443.498ZM874.799 428.5C877.118 426.008 879.429 423.547 881.733 421.122L878.109 417.678C875.791 420.117 873.468 422.591 871.139 425.095L874.799 428.5ZM888.789 413.796C891.184 411.345 893.571 408.942 895.948 406.594L892.434 403.036C890.034 405.408 887.627 407.832 885.213 410.302L888.789 413.796ZM903.226 399.557C905.711 397.209 908.186 394.93 910.649 392.728L907.318 389C904.816 391.235 902.308 393.546 899.792 395.923L903.226 399.557ZM918.264 386.149C920.91 383.945 923.541 381.842 926.158 379.852L923.131 375.873C920.45 377.912 917.761 380.061 915.064 382.307L918.264 386.149ZM934.321 373.983C937.169 372.061 939.995 370.288 942.799 368.678L940.31 364.342C937.39 366.018 934.461 367.856 931.523 369.839L934.321 373.983ZM951.63 364.129C954.726 362.724 957.79 361.543 960.821 360.602L959.338 355.827C956.088 356.836 952.829 358.094 949.564 359.576L951.63 364.129ZM970.322 358.437C973.583 357.977 976.806 357.827 979.992 358.006L980.274 353.014C976.74 352.815 973.188 352.983 969.624 353.486L970.322 358.437ZM989.466 359.564C991.01 359.991 992.548 360.506 994.083 361.111L995.917 356.459C994.22 355.79 992.515 355.22 990.8 354.745L989.466 359.564ZM994.083 361.111C995.504 361.671 996.954 362.294 998.432 362.979L1000.53 358.443C998.974 357.72 997.435 357.057 995.917 356.459L994.083 361.111ZM1007.1 367.509C1009.82 369.077 1012.61 370.816 1015.46 372.713L1018.23 368.55C1015.3 366.6 1012.42 364.805 1009.6 363.178L1007.1 367.509ZM1023.57 378.4C1026.17 380.308 1028.8 382.329 1031.48 384.456L1034.59 380.542C1031.87 378.38 1029.18 376.321 1026.54 374.372L1023.57 378.4ZM1039.17 390.767C1041.64 392.849 1044.13 395.011 1046.64 397.245L1049.96 393.507C1047.42 391.247 1044.9 389.059 1042.4 386.948L1039.17 390.767ZM1054.02 403.941C1056.43 406.176 1058.86 408.472 1061.31 410.822L1064.78 407.217C1062.31 404.846 1059.85 402.53 1057.42 400.273L1054.02 403.941ZM1068.4 417.747C1070.74 420.061 1073.08 422.42 1075.44 424.819L1079.01 421.317C1076.64 418.902 1074.28 416.527 1071.92 414.195L1068.4 417.747ZM1082.41 432.016C1084.69 434.389 1086.96 436.795 1089.24 439.232L1092.89 435.814C1090.6 433.365 1088.31 430.945 1086.03 428.559L1082.41 432.016ZM1096.04 446.567C1098.28 449.005 1100.52 451.468 1102.76 453.954L1106.47 450.608C1104.22 448.111 1101.97 445.636 1099.73 443.186L1096.04 446.567ZM1109.41 461.397C1111.61 463.886 1113.82 466.393 1116.02 468.915L1119.78 465.628C1117.58 463.097 1115.36 460.58 1113.15 458.082L1109.41 461.397ZM1122.55 476.456C1124.72 478.98 1126.88 481.515 1129.04 484.06L1132.85 480.826C1130.69 478.273 1128.51 475.729 1126.34 473.196L1122.55 476.456ZM1135.47 491.699C1137.62 494.256 1139.75 496.819 1141.87 499.384L1145.72 496.197C1143.6 493.624 1141.46 491.054 1139.31 488.489L1135.47 491.699ZM1148.21 507.093C1150.33 509.683 1152.44 512.273 1154.53 514.859L1158.42 511.713C1156.32 509.12 1154.21 506.524 1152.08 503.926L1148.21 507.093ZM1160.8 522.637C1162.89 525.252 1164.97 527.859 1167.03 530.456L1170.95 527.348C1168.88 524.745 1166.8 522.131 1164.7 519.511L1160.8 522.637ZM1173.24 538.313C1175.3 540.939 1177.35 543.552 1179.37 546.147L1183.31 543.074C1181.29 540.473 1179.24 537.855 1177.17 535.222L1173.24 538.313ZM1185.53 554.088C1187.59 556.753 1189.62 559.395 1191.62 562.01L1195.59 558.97C1193.59 556.35 1191.55 553.702 1189.49 551.032L1185.53 554.088ZM1197.66 569.925C1199.72 572.635 1201.74 575.31 1203.73 577.945L1207.72 574.936C1205.73 572.295 1203.7 569.615 1201.64 566.9L1197.66 569.925ZM1209.73 585.94C1211.76 588.647 1213.74 591.302 1215.66 593.902L1219.68 590.922C1217.75 588.318 1215.76 585.657 1213.74 582.946L1209.73 585.94ZM1221.64 601.979C1223.68 604.759 1225.67 607.46 1227.58 610.076L1231.61 607.125C1229.7 604.505 1227.71 601.798 1225.66 599.013L1221.64 601.979ZM1233.47 618.172C1235.53 621.011 1237.49 623.719 1239.33 626.283L1243.39 623.363C1241.54 620.794 1239.58 618.08 1237.52 615.237L1233.47 618.172ZM1245.16 634.418C1247.3 637.415 1249.22 640.125 1250.91 642.518L1254.99 639.633C1253.3 637.234 1251.37 634.518 1249.23 631.515L1245.16 634.418Z"
                fill="#65255D"
              />
              <defs>
                <radialGradient
                  id="paint0_radial_215:18"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(754 165) rotate(102.864) scale(491.844 777.111)"
                >
                  <stop offset="0.0001" stopColor="#FF31E8" />
                  <stop offset="1" stopColor="#010313" stopOpacity="0" />
                </radialGradient>
              </defs>
            </svg>
          </figure>
        </section>
        <section className="conc-sect">
          <div className="wtm-header-container">
            <h3 className="wtm-header conc">
              The <br></br> Conclusion
            </h3>
          </div>
          <div>
            <img id="conc-icon" src={icon} alt="Bejour Icon" />
          </div>
        </section>
      </div>
    </>
  );
}
